import React from 'react';
import { WidgetblockResponseModel } from '@metservicedev/platforms-services-interface/src/services/platformsWidgetblock/WidgetblockRequestModels';
import { IStage } from '@metservicedev/platforms-services-interface';
import { GetCfjsonResponse } from '@metservicedev/platforms-services-interface/src/services/movIntegrationMDS/MovIntegrationMDSModel';
import { basicDataset } from '@mono/types/src/mds';

import WidgetblockContainer from './WidgetBlockContainer';

interface ImportedWidgetblockContainerProps {
    date: string;
    stage: IStage;
    renderingForPDF?: boolean;
    cfjsons?: GetCfjsonResponse[];
    timezone: string;
    datasets?: basicDataset[];
    weatherWidget?: WidgetblockResponseModel;
    metjwt?: string;
}
export const ImportedWidgetblockContainer = ({
    date,
    stage,
    renderingForPDF,
    timezone,
    cfjsons,
    datasets,
    weatherWidget,
    metjwt,
}: ImportedWidgetblockContainerProps) => {
    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {!weatherWidget && <div>... Loading ...</div>}
            {weatherWidget && (
                <div style={{ height: '100%', width: '100%' }}>
                    <WidgetblockContainer
                        widgetblockType={weatherWidget.type}
                        viewblockState={weatherWidget.state}
                        date={date}
                        timezone={timezone && timezone !== 'Delegate' ? timezone : weatherWidget.timezone}
                        updateInterval={1000 * 60 * 60 * 24}
                        stage={stage}
                        renderingForPDF={renderingForPDF}
                        cfjsons={cfjsons}
                        datasets={datasets}
                        metjwt={metjwt}
                    />
                </div>
            )}
        </div>
    );
};
